<template>
    <div class="col-lg-12" v-if="isLoadingBlade">
        <div class="d-flex justify-content-center">
            <img :src="loadingBladeUrl" />
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import axios from 'axios';

    export default {
        data() {
            return {
                isLoadingBlade: true
            }
        },
        created() {// call logout function
            this.logout();
        },
        computed: {
        ...mapGetters(['getLogoutUserUrl', 'getHospitalAccessToken', 'loadingBladeUrl'])
        },
        methods: {
            ...mapActions(['destroyAccessToken']),
            logout() {
                const header = {Authorization: `Bearer ${this.getHospitalAccessToken}`};
                axios.post(this.getLogoutUserUrl, {'access_token' : this.getHospitalAccessToken},
                    { headers: header })// detroy server token
                    .then(() => {
                        this.destroyAccessToken();// destroy local token
                    })
                    .catch(err => {
                        alert(err.message);
                    })
            }
        },
    }
</script>